import { memo } from "react";
import RequestDetailsCard from "./RequestDetailsCard";
import ExtraMaterials from "./ExtraMaterials";
import CostBreakdown from "./CostBreakdown";

// const FullRequestDetails = () => {};
const FullRequestDetails = memo(({ request }) => {
    if (!request) return null;

    const {
        ftm_request_id,
        ftm_request_total_material_net_price,
        request_materials = []
    } = request;

    return (
        <>
            <RequestDetailsCard
                key={ftm_request_id}
                request={request}
            />

            {request_materials.map((material) => (
                <ExtraMaterials
                    key={material?.id || material?.material_id}
                    material={material}
                />
            ))}

            <CostBreakdown
                total_material_net_price={
                    ftm_request_total_material_net_price
                }
            />
            <hr className="horizontal white mt-0 mb-2" />
        </>
    );
});

export default FullRequestDetails;